module.exports = __webpack_public_path__ + "static/media/jorge-perazzo.75f2d637.png";